module.exports = __webpack_public_path__ + "media/images/brands/hankook-truck-masters/favicon-80696d8299e6f40d87347a3e89faa211.png";